import React, { useContext } from 'react';

import { ContainerHeader, ContainerTitles } from './Header.styles';
import { I18nProviderContext } from 'contexts/I18nProvider';

interface HeaderProps {
	isGeneralRisk: boolean;
}

export const Header = ({ isGeneralRisk }: HeaderProps): JSX.Element => {
	const { translate } = useContext(I18nProviderContext);

	const conditionalTextSubtitle = isGeneralRisk ? 'generalRisk' : 'default';

	return (
		<ContainerHeader>
			<ContainerTitles>
				<h2>{translate('views.campaigns.results.mainTitle')}</h2>
				<p>
					{translate(
						`views.campaigns.results.subtitle.${conditionalTextSubtitle}`,
					)}
				</p>
			</ContainerTitles>
		</ContainerHeader>
	);
};
